export default "__VITE_ASSET__DVJLzeLI__"